import { FC, HTMLAttributes, memo } from 'react';

import DialogSubtext from '../Dialog/DialogSubtext';

import s from './Modal.module.scss';

interface Props {
  subtext?: string;
  subtextType?: 'default' | 'small';
}

type NativeAttrs = Omit<HTMLAttributes<HTMLElement>, keyof Props>;

export type ModalBodyProps = Props & NativeAttrs;

const ModalBody: FC<React.PropsWithChildren<React.PropsWithChildren<ModalBodyProps>>> = ({ children, subtext, subtextType = 'default', ...props }) => {
  const renderComponent = () => {
    if (subtext) {
      return <DialogSubtext subtext={subtext} subtextType={subtextType} />;
    }
    return children;
  };
  return (
    <div className={s.body} {...props}>
      {renderComponent()}
    </div>
  );
};

const MemoModalBody = memo(ModalBody);
export default MemoModalBody;
